import React from "react";
import "../components/Styles/AgreementDrafting.css";

function AgreementDrafting() {
  return (
    <div className="agreement-page">

      {/* HERO SECTION */}

      <div className="agreement-hero">

        <div className="agreement-overlay"></div>

        <div className="container">

          <div className="agreement-content">

            {/* BREADCRUMB */}

            <div className="breadcrumb">

              <span>Home</span>

              <span className="arrow">›</span>

              <span>Property</span>

              <span className="arrow">›</span>

              <span className="active">
                Agreement to Sale Drafting
              </span>

            </div>

            {/* MAIN CONTENT */}

            <h1>
              Agreement to Sale <br />
              Drafting
            </h1>

            <p className="agreement-description">

              Secure your property transaction with our comprehensive
              Agreement to Sale Drafting service. 

              
            </p>

            {/* RATINGS */}

            <div className="rating-section">

              <div className="rating-top">

                <h2>4.7</h2>

                <span>(346 reviews)</span>

              </div>

              <div className="stars">
                ⭐ ⭐ ⭐ ⭐ ⭐
              </div>

              <p>
                56781 People purchased
              </p>

            </div>

          </div>

        </div>

      </div>

      {/* =========================
   WHAT IS AGREEMENT SECTION
========================= */}

<div className="agreement-info-section">

  <div className="container">

    <div className="agreement-left-panel">

      <div className="last-update">
        <span>
          Last Updated: Apr 8, 2024
        </span>
      </div>

      <h2>
        What is an agreement to sale?
      </h2>

      <p>
        An Agreement to Sale is like a promise or a plan for buying
        and selling property. Think of it as a written agreement
        that comes before the final sale deed. In this agreement,
        the seller and the buyer outline the terms and conditions
        of the property sale, like the price, the payment plan,
        and any other important details about the deal.
      </p>

      <p>
        <strong>
          It's like a roadmap for how the property sale will happen.
          This agreement doesn't immediately transfer the property
          ownership, but it's a commitment that the property will
          be sold and bought under the conditions they've agreed upon.
          Once all the terms are met, the actual transfer of the
          property happens later with a Sale Deed.
        </strong>
      </p>

    </div>

  </div>

</div>

{/* =========================
   HOW IT WORKS SECTION
========================= */}

<div className="agreement-how-section">

  <div className="container">

    <h2 className="agreement-main-title">
      How it works?
    </h2>

    <div className="agreement-how-grid">

      {/* CARD 1 */}

      <div className="agreement-how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/2921/2921222.png"
          alt=""
        />

        <h3>
          Property document collection
        </h3>

        <p>
          All the property papers can be uploaded
          or hard copies can be collected.
        </p>

      </div>

      {/* CARD 2 */}

      <div className="agreement-how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/942/942748.png"
          alt=""
        />

        <h3>
          Review & Analysis
        </h3>

        <p>
          Senior Property Lawyer will analyse
          & prepare detailed report.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="agreement-how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/3050/3050525.png"
          alt=""
        />

        <h3>
          Detailed consultation
        </h3>

        <p>
          Your consultation call with Senior
          property lawyer to discuss your report.
        </p>

      </div>

      {/* CARD 4 */}

      <div className="agreement-how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/190/190411.png"
          alt=""
        />

        <h3>
          Delivery
        </h3>

        <p>
          Your detailed property verification
          report will be delivered in 5 days.
        </p>

      </div>

    </div>

  </div>

</div>

{/* =========================
   PROPERTY DESCRIPTION SECTION
========================= */}

<div className="agreement-description-section">

  <div className="container">

    {/* BOX 1 */}

    <div className="agreement-description-box">

      <h2>
        Why is it critical to have a professionally
        drafted Agreement to Sale?
      </h2>

      <p>
        Having a professionally drafted Agreement
        to Sale is really important because it's
        like setting the ground rules for buying
        and selling property.
      </p>

      <p>
        A professional will make sure that all the
        important details are included, like the
        price, when and how payments should be made,
        and what happens if something doesn't go as planned.
      </p>

      <p>
        They know all the legal stuff that needs to
        be in there to protect both the buyer and
        the seller.
      </p>

      <p>
        If the agreement is clear and thorough,
        it can help prevent misunderstandings or
        disputes later on.
      </p>

    </div>

    {/* BOX 2 */}

    <div className="agreement-description-box">

      <h2>
        Key Elements to Check in an Agreement to Sell
      </h2>

      <p>
        When drafting or reviewing an Agreement to Sell,
        pay particular attention to the following elements:
      </p>

      <ol>

        <li>
          <strong>Parties Involved:</strong>
          The names, addresses, and details of
          buyer and seller should be clearly stated.
        </li>

        <li>
          <strong>Description of Property:</strong>
          The agreement should include proper
          property details, location, and size.
        </li>

        <li>
          <strong>Sale Price & Payment Terms:</strong>
          Payment amount and payment schedule
          should be clearly mentioned.
        </li>

        <li>
          <strong>Possession Date:</strong>
          The date when the buyer will get
          property possession.
        </li>

        <li>
          <strong>Conditions:</strong>
          Important conditions before or after
          sale should be included.
        </li>

        <li>
          <strong>Representations & Warranties:</strong>
          Seller warranties about ownership and
          property legality.
        </li>

        <li>
          <strong>Indemnity Clause:</strong>
          Protection for buyer against title defects.
        </li>

        <li>
          <strong>Dispute Resolution:</strong>
          Process for solving disputes through
          mediation or legal methods.
        </li>

        <li>
          <strong>Termination Clause:</strong>
          Conditions where agreement can be terminated.
        </li>

      </ol>

    </div>

  </div>

</div>

{/* =========================
   CHAT SECTION
========================= */}

<div className="agreement-chat-section">

  <div className="container">

    <div className="agreement-chat-box">

      <div className="agreement-chat-left">

        <h2>
          Chat with us
        </h2>

        <h3>
          Before you Buy your Property.
        </h3>

      </div>

      <div className="agreement-chat-right">

        <a
          href="https://api.whatsapp.com/send?phone=918743940556"
          target="_blank"
          rel="noreferrer"
        >
          Chat Now
        </a>

      </div>

      <img
        className="chat-bg-image"
        src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1974&auto=format&fit=crop"
        alt=""
      />

    </div>

  </div>

</div>

{/* =========================
   VIRTUAL SECTION
========================= */}

<div className="agreement-virtual-section">

  <div className="container">

    <h2>
      All property legal solutions
      under one roof
    </h2>

    <p>
      With more than 35000 verified properties
      LegalAxis offers most Reliable property
      legal service
    </p>

  </div>

</div>

{/* =========================
   ONLINE SECTION
========================= */}

<div className="agreement-online-section">

  <div className="container">

    <div className="agreement-online-grid">

      {/* CARD 1 */}

      <div className="agreement-online-card">

        <h3>
          35K+ Properties
        </h3>

        <p>
          With more than 35000 verified properties
          LegalAxis offers most Reliable property
          legal service
        </p>

      </div>

      {/* CARD 2 */}

      <div className="agreement-online-card">

        <h3>
          All in One Solution
        </h3>

        <p>
          Property verification, legal drafting
          for property and registration everything
          under one roof.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="agreement-online-card">

        <h3>
          Trusted in 80 countries
        </h3>

        <p>
          Indians around the globe in more than
          80 countries trust LegalAxis for their
          property matters.
        </p>

      </div>

    </div>

  </div>

</div>

    </div>
  );
}

export default AgreementDrafting;